import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { TrackAuthority } from '../models/trackauthority';
import { Direction } from '../models/direction.enum';
import { AuthorityPoint } from '../models/authoritypoint';
import { DataService } from '../services/data.service';
import { IUserConfirmation, IUserConfirmationLabel } from '../models/userconfirmation';
import { Status } from '../models/status.enum';
import { DisplayStatus } from '../models/displaystatus.enum';
import { Source } from '../models/source.enum';
import { AffirmationService } from '../services/affirmation.service';

@Component({
  selector: 'user-confirmation-dialog',
  templateUrl: './userconfirmation.component.html',
  styleUrls: ['./userconfirmation.component.scss']
})
export class UserConfirmationDialogComponent implements OnChanges {
  Status = Status;
  Source = Source;
  userConfirmationList: IUserConfirmation[];
  allAccepted: boolean = false;
  display: boolean = false;
  blockDialog: boolean = true;
  title: string = '';
  confirmBtnTitle: String = 'Confirm';

  @Input() authority: TrackAuthority = null;

  /*TODO PHASE2: This needs to be changed in phase 2. Action should not represent both the field and its value. 
  It should represent an action(UPDATE_SOURCE/UPDATE_STATE/ETC) which may contain the relevant information(field, value, etc) encapsulated.*/
  @Input() action: Status | Source;
  @Input() sharedAuthorityActionType = '';

  @Output() userAccept: EventEmitter<TrackAuthority> = new EventEmitter();
  @Output() userCancel: EventEmitter<TrackAuthority> = new EventEmitter();

  constructor(private dataService: DataService, private affirmationService: AffirmationService) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.confirmBtnTitle =
      this.action === Status.AUTHORITY_ACCEPTED
        ? 'Accept Authority'
        : this.action === Status.RELEASE_REQUESTED
        ? 'Release Authority'
        : 'Confirm';
    this.display = this.authority != null;
    this.blockDialog = true;
    this.userConfirmationList = new Array<IUserConfirmation>();
    this.allAccepted = false;
    if (changes.authority && this.display) {
      this.affirmationService.getAffirmations(this.authority, this.action).then(response => {
        this.userConfirmationList = response;
        this.blockDialog = false;
      });
    }
    if (this.action === Status.AUTHORITY_USER_APPROVED) {
      this.title = 'Review Authority';
    } else if (this.action === Status.RELEASE_USER_APPROVED) {
      this.title = 'Accept Release Authority';
    } else if (this.action === Status.RELEASE_REQUESTED) {
      this.title = 'Release Authority';
    } else if (this.action === Source.TRANSFER_TO_PAPER) {
      this.title = 'Transfer To Paper';
    } else if (this.action === Status.CHANGE_USER_APPROVED || this.action === Status.CHANGE_REQUEST ) {
      this.title = 'Modify: Authority';
    } else if (this.action === Status.SHARING_AUTHORITY) {
      this.title = 'Accept Shared Authority';
    } else if (this.action === Status.SHARING_RELEASE) {
      this.title = 'Release Shared Authority';
    } else {
      this.title = '';
    }
    if (
      this.authority !== null &&
      this.authority.ec1Number !== undefined &&
      this.authority.ec1Number !== null &&
      (this.authority.displayStatus === DisplayStatus.ACTIVE || this.authority.displayStatus === DisplayStatus.RELEASED)
    ) {
      this.title = this.title + ' #' + this.authority.ec1Number;
    }
  }

  toggleUserConfirmationLabelStatus(userConfirmation: IUserConfirmation, userConfirmationLabel: IUserConfirmationLabel): void {
    let requestedStatus: boolean = !userConfirmationLabel.accepted;
    if (userConfirmation.confirmType === 'ME') {
      for (var userConfirmationLabelItem of userConfirmation.userConfirmationLabelList) {
        userConfirmationLabelItem.accepted = false;
      }
    }
    userConfirmationLabel.accepted = requestedStatus;
    this.updateAllReviewed();
  }

  accept(): void {
    this.authority.userConfirmationList = this.userConfirmationList;
    this.userAccept.emit(this.authority);
  }

  cancel(): void {
    this.userCancel.emit(this.authority);
  }

  private updateAllReviewed(): void {
    this.allAccepted = true;
    for (var userConfirmation of this.userConfirmationList) {
      userConfirmation.accepted = !(userConfirmation.confirmType === 'ME');

      for (var userConfirmationLabel of userConfirmation.userConfirmationLabelList) {
        if (userConfirmation.confirmType === 'ME') {
          userConfirmation.accepted = userConfirmation.accepted || userConfirmationLabel.accepted;
        } else {
          userConfirmation.accepted = userConfirmation.accepted && userConfirmationLabel.accepted;
        }
      }

      this.allAccepted = this.allAccepted && userConfirmation.accepted;
    }
  }
}
